<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.wageAverage.regularMaleWage.$invalid
      || $v.wageAverage.nonRegularMaleWage.$invalid 
      || $v.wageAverage.regularFemaleWage.$invalid
      || $v.wageAverage.nonRegularFemaleWage.$invalid
      || $v.wageAverage.regularMaleCount.$invalid
      || $v.wageAverage.nonRegularMaleCount.$invalid 
      || $v.wageAverage.regularFemaleCount.$invalid
      || $v.wageAverage.nonRegularFemaleCount.$invalid
      || $v.wageAverage.resultMemo.$invalid 
      || $v.wageAverage.actionMemo.$invalid">

      <div v-if="$v.wageAverage.regularMaleWage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">総賃金額（正社員・男性）　　　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularMaleWage.$invalid && !$v.wageAverage.regularMaleWage.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularMaleWage.$invalid && $v.wageAverage.regularMaleWage.numeric && !$v.wageAverage.regularMaleWage.between" validation="between" valueMin="0" valueMax="9999999999"/>
      </div>

      <div v-if="$v.wageAverage.nonRegularMaleWage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">総賃金額（非正規社員・男性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularMaleWage.$invalid && !$v.wageAverage.nonRegularMaleWage.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularMaleWage.$invalid && $v.wageAverage.nonRegularMaleWage.numeric && !$v.wageAverage.nonRegularMaleWage.between" validation="between" valueMin="0" valueMax="9999999999"/>
      </div>

      <div v-if="$v.wageAverage.regularFemaleWage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">総賃金額（正社員・女性）　　　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularFemaleWage.$invalid && !$v.wageAverage.regularFemaleWage.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularFemaleWage.$invalid && $v.wageAverage.regularFemaleWage.numeric && !$v.wageAverage.regularFemaleWage.between" validation="between" valueMin="0" valueMax="9999999999"/>
      </div>

      <div v-if="$v.wageAverage.nonRegularFemaleWage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">総賃金額（非正規社員・女性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularFemaleWage.$invalid && !$v.wageAverage.nonRegularFemaleWage.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularFemaleWage.$invalid && $v.wageAverage.nonRegularFemaleWage.numeric && !$v.wageAverage.nonRegularFemaleWage.between" validation="between" valueMin="0" valueMax="9999999999"/>
      </div>

      <!-- 対象人数 -->
      <div v-if="$v.wageAverage.regularMaleCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">対象人数（正社員・男性）　　　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularMaleCount.$invalid && !$v.wageAverage.regularMaleCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularMaleCount.$invalid && $v.wageAverage.regularMaleCount.numeric && !$v.wageAverage.regularMaleCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.wageAverage.nonRegularMaleCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">対象人数（非正規社員・男性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularMaleCount.$invalid && !$v.wageAverage.nonRegularMaleCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularMaleCount.$invalid && $v.wageAverage.nonRegularMaleCount.numeric && !$v.wageAverage.nonRegularMaleCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.wageAverage.regularFemaleCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">対象人数（正社員・女性）　　　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularFemaleCount.$invalid && !$v.wageAverage.regularFemaleCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularFemaleCount.$invalid && $v.wageAverage.regularFemaleCount.numeric && !$v.wageAverage.regularFemaleCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.wageAverage.nonRegularFemaleCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">対象人数（非正規社員・女性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularFemaleCount.$invalid && !$v.wageAverage.nonRegularFemaleCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularFemaleCount.$invalid && $v.wageAverage.nonRegularFemaleCount.numeric && !$v.wageAverage.nonRegularFemaleCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <!-- 年間平均賃金 -->
<!--      <div v-if="$v.wageAverage.regularMaleWageAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年間平均賃金（正社員・男性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularMaleWageAverage.$invalid && !$v.wageAverage.regularMaleWageAverage.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularMaleWageAverage.$invalid && $v.wageAverage.regularMaleWageAverage.numeric && !$v.wageAverage.regularMaleWageAverage.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.wageAverage.nonRegularMaleWageAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年間平均賃金（非正規社員・男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularMaleWageAverage.$invalid && !$v.wageAverage.nonRegularMaleWageAverage.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularMaleWageAverage.$invalid && $v.wageAverage.nonRegularMaleWageAverage.numeric && !$v.wageAverage.nonRegularMaleWageAverage.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.wageAverage.regularFemaleWageAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年間平均賃金（正社員・女性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularFemaleWageAverage.$invalid && !$v.wageAverage.regularFemaleWageAverage.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.regularFemaleWageAverage.$invalid && $v.wageAverage.regularFemaleWageAverage.numeric && !$v.wageAverage.regularFemaleWageAverage.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.wageAverage.nonRegularFemaleWageAverage.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年間平均賃金（非正規社員・女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularFemaleWageAverage.$invalid && !$v.wageAverage.nonRegularFemaleWageAverage.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.wageAverage.nonRegularFemaleWageAverage.$invalid && $v.wageAverage.nonRegularFemaleWageAverage.numeric && !$v.wageAverage.nonRegularFemaleWageAverage.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>-->

      <div v-if="$v.wageAverage.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.wageAverage.resultMemo.$invalid && !$v.wageAverage.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.wageAverage.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.wageAverage.actionMemo.$invalid && !$v.wageAverage.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table02">
        <p class="l-formGroup__label u-mb10">総賃金額</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit is-extra-wide">
                  <TextBox v-model.trim="$v.wageAverage.$model.regularMaleWage" type="text" name="wageAverage.regularMaleWage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">千円</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit is-extra-wide">
                  <TextBox v-model.trim="$v.wageAverage.$model.nonRegularMaleWage" type="text" name="wageAverage.nonRegularMaleWage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">千円</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleWage" :unit="this.unit1"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit is-extra-wide">
                  <TextBox v-model.trim="$v.wageAverage.$model.regularFemaleWage" type="text" name="wageAverage.regularFemaleWage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">千円</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit is-extra-wide">
                  <TextBox v-model.trim="$v.wageAverage.$model.nonRegularFemaleWage" type="text" name="wageAverage.nonRegularFemaleWage" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">千円</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleWage" :unit="this.unit1"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__space"></div>

      <div class="human-capitalt-data-wrap__table02">
        <p class="l-formGroup__label u-mb10">対象人数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.wageAverage.$model.regularMaleCount" type="text" name="wageAverage.regularMaleCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.wageAverage.$model.nonRegularMaleCount" type="text" name="wageAverage.nonRegularMaleCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleCount" :unit="this.unit2"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.wageAverage.$model.regularFemaleCount" type="text" name="wageAverage.regularFemaleCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.wageAverage.$model.nonRegularFemaleCount" type="text" name="wageAverage.nonRegularFemaleCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleCount" :unit="this.unit2"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table02-->
    </div>

    <div class="human-capitalt-data-wrap">
  
      <div class="human-capitalt-data-wrap__table02">
        <p class="l-formGroup__label u-mb10">年間平均賃金</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.calcRegularMaleWageAverage" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.calcNonRegularMaleWageAverage" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><strong><Currency :value="this.calcAchievementWageAverageMale" :unit="this.unit1"/></strong></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.calcRegularFemaleWageAverage" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.calcNonRegularFemaleWageAverage" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><strong><Currency :value="this.calcAchievementWageAverageFemale" :unit="this.unit1"/></strong></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table02-->

      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__results is-harf">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            賃金差異
            <strong><Currency :value="this.calcAchievementWageAverageDiff"/></strong>%
          </div>
      </div>
    </div>

  </div><!--/human-capitalt-data-wrap-->

    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="wageAverage.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(wageAverage.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="wageAverage.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
    Currency,
  },
  props: {
    // 表示年度の年間平均賃金データ
    wageAverage: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "千円",
      unit2: "名",
      unit3: "％",
    }
  },
  computed: {
    sumOfMaleWage() {
      if ( !(this.wageAverage.regularMaleWage!=null && this.wageAverage.nonRegularMaleWage!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularMaleWage).length * String(this.wageAverage.nonRegularMaleWage).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularMaleWage) || isNaN(this.wageAverage.nonRegularMaleWage)) {
        return null;
      }else{
        return Number(this.wageAverage.regularMaleWage) + Number(this.wageAverage.nonRegularMaleWage);
      }
    },
    sumOfFemaleWage() {
      if ( !(this.wageAverage.regularFemaleWage!=null && this.wageAverage.nonRegularFemaleWage!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularFemaleWage).length * String(this.wageAverage.nonRegularFemaleWage).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularFemaleWage) || isNaN(this.wageAverage.nonRegularFemaleWage)) {
        return null;
      }else{
        return Number(this.wageAverage.regularFemaleWage) + Number(this.wageAverage.nonRegularFemaleWage);
      }
    },
    sumOfMaleCount() {
      if ( !(this.wageAverage.regularMaleCount!=null && this.wageAverage.nonRegularMaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularMaleCount).length * String(this.wageAverage.nonRegularMaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularMaleCount) || isNaN(this.wageAverage.nonRegularMaleCount)) {
        return null;
      }else{
        return Number(this.wageAverage.regularMaleCount) + Number(this.wageAverage.nonRegularMaleCount);
      }
    },
    sumOfFemaleCount() {
      if ( !(this.wageAverage.regularFemaleCount!=null && this.wageAverage.nonRegularFemaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularFemaleCount).length * String(this.wageAverage.nonRegularFemaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularFemaleCount) || isNaN(this.wageAverage.nonRegularFemaleCount)) {
        return null;
      }else{
        return Number(this.wageAverage.regularFemaleCount) + Number(this.wageAverage.nonRegularFemaleCount);
      }
    },
    /**
     * 年間平均賃金（男性・正社員）算出処理
     */
    calcRegularMaleWageAverage() {
      if ( !(this.wageAverage.regularMaleWage!=null && this.wageAverage.regularMaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularMaleWage).length * String(this.wageAverage.regularMaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularMaleWage) || isNaN(this.wageAverage.regularMaleCount)) {
        return null;
      }else{
        if ( this.wageAverage.regularMaleCount == 0 ) return null;
        if ( this.wageAverage.regularMaleWage == 0 ) return 0;
        let val = (this.wageAverage.regularMaleWage / this.wageAverage.regularMaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 年間平均賃金（男性・非正規社員）算出処理
     */
    calcNonRegularMaleWageAverage() {
      if ( !(this.wageAverage.nonRegularMaleWage!=null && this.wageAverage.nonRegularMaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.nonRegularMaleWage).length * String(this.wageAverage.nonRegularMaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.nonRegularMaleWage) || isNaN(this.wageAverage.nonRegularMaleCount)) {
        return null;
      }else{
        if ( this.wageAverage.nonRegularMaleCount == 0 ) return null;
        if ( this.wageAverage.nonRegularMaleWage == 0 ) return 0;
        let val = (this.wageAverage.nonRegularMaleWage / this.wageAverage.nonRegularMaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 年間平均賃金（女性・正社員）算出処理
     */
    calcRegularFemaleWageAverage() {
      if ( !(this.wageAverage.regularFemaleWage!=null && this.wageAverage.regularFemaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularFemaleWage).length * String(this.wageAverage.regularFemaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularFemaleWage) || isNaN(this.wageAverage.regularFemaleCount)) {
        return null;
      }else{
        if ( this.wageAverage.regularFemaleCount == 0 ) return null;
        if ( this.wageAverage.regularFemaleWage == 0 ) return 0;
        let val = (this.wageAverage.regularFemaleWage / this.wageAverage.regularFemaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 年間平均賃金（女性・非正規社員）算出処理
     */
    calcNonRegularFemaleWageAverage() {
      if ( !(this.wageAverage.nonRegularFemaleWage!=null && this.wageAverage.nonRegularFemaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.nonRegularFemaleWage).length * String(this.wageAverage.nonRegularFemaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.nonRegularFemaleWage) || isNaN(this.wageAverage.nonRegularFemaleCount)) {
        return null;
      }else{
        if ( this.wageAverage.nonRegularFemaleCount == 0 ) return null;
        if ( this.wageAverage.nonRegularFemaleWage == 0 ) return 0;
        let val = (this.wageAverage.nonRegularFemaleWage / this.wageAverage.nonRegularFemaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 実績　年間平均賃金（男性）算出処理
     */
    calcAchievementWageAverageMale() {
      if ( !(this.sumOfMaleWage!=null && this.sumOfMaleCount!=null) ) {
        return null;
      }else if ( String(this.sumOfMaleWage).length * String(this.sumOfMaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.sumOfMaleWage) || isNaN(this.sumOfMaleCount)) {
        return null;
      }else{
        if ( this.sumOfMaleCount == 0 ) return null;
        if ( this.sumOfMaleWage == 0 ) return 0;
        let val = (this.sumOfMaleWage / this.sumOfMaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 実績　年間平均賃金（女性）算出処理
     */
    calcAchievementWageAverageFemale() {
      if ( !(this.sumOfFemaleWage!=null && this.sumOfFemaleCount!=null) ) {
        return null;
      }else if ( String(this.sumOfFemaleWage).length * String(this.sumOfFemaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.sumOfFemaleWage) || isNaN(this.sumOfFemaleCount)) {
        return null;
      }else{
        if ( this.sumOfFemaleCount == 0 ) return null;
        if ( this.sumOfFemaleWage == 0 ) return 0;
        let val = (this.sumOfFemaleWage / this.sumOfFemaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 実績　年間平均賃金（賃金差異）算出処理
     */
    calcAchievementWageAverageDiff() {
      if ( !(this.calcAchievementWageAverageFemale!=null && this.calcAchievementWageAverageMale!=null) ) {
        return null;
      }else if ( String(this.calcAchievementWageAverageFemale).length * String(this.calcAchievementWageAverageMale).length == 0) {
        return null;
      }else if ( isNaN(this.calcAchievementWageAverageFemale) || isNaN(this.calcAchievementWageAverageMale)) {
        return null;
      }else{
        if ( this.calcAchievementWageAverageMale == 0 ) return null;
        if ( this.calcAchievementWageAverageFemale == 0 ) return 0;
        let val = (this.calcAchievementWageAverageFemale / this.calcAchievementWageAverageMale) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
  },
  validations: {
    wageAverage: {
      regularMaleWage : { numeric, between: between(0,9999999999) },         // 売上（実績）
      nonRegularMaleWage : { numeric, between: between(0,9999999999) },         // 売上（実績）
      regularFemaleWage : { numeric, between: between(0,9999999999) },         // 売上（実績）
      nonRegularFemaleWage : { numeric, between: between(0,9999999999) },         // 売上（実績）
      regularMaleCount : { numeric, between: between(0,99999) },         // 売上（実績）
      nonRegularMaleCount : { numeric, between: between(0,99999) },         // 売上（実績）
      regularFemaleCount : { numeric, between: between(0,99999) },         // 売上（実績）
      nonRegularFemaleCount : { numeric, between: between(0,99999) },         // 売上（実績）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    wageAverage() {
      this.inputWageAverage();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputWageAverage() {
      this.$emit("change-wage-average", {
        wageAverage: this.wageAverage,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
